export class PostNotFoundError extends Error { }
